import RsvpPage from './rsvp';
import RsvpService from '../../services/RsvpService';

const state = {
  	name: 'rsvp',
  	url: '/rsvp/:account_uuid/:contact_uuid/:event_id?{env}',
  	component: RsvpPage,
    resolve: [
        {
            token: 'main',
            deps: ['$transition$'],
            resolveFn: (trans) => {
                return new RsvpService().getRsvp(trans.params());
            }
        },
        {
            token: 'check',
            deps: ['main', '$transition$'],
            resolveFn: (data, $transition$) => {
              // Reroute the user if the event doesnt exist
                if (!data.event) {
                    $transition$.router.stateService.go('404');
                }

                return data;
            }
        }, 
    ]
};

export default state;